import { render, staticRenderFns } from "./VLegend.vue?vue&type=template&id=76977a17"
import script from "./VLegend.vue?vue&type=script&lang=js"
export * from "./VLegend.vue?vue&type=script&lang=js"
import style0 from "./VLegend.vue?vue&type=style&index=0&id=76977a17&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports